import BaseCommand from "@/models/api/commands/BaseCommand";

export class ChangeContractDescriptionCommand extends BaseCommand {
  CommandName = "ChangeContractDescription";
  Command: { Value: string };
  constructor(sessionId: string, operationId: string, value: string) {
    super(sessionId, operationId);
    this.Command = { Value: value };
  }
}
